<template>
  <svg class="dropoff-path"
       width="60"
       height="120"
       :style="{
         left: layout.width - 10 - Math.min(9, (Math.max(0, dropPathInfo.width - 10))) + 'px',
         top: top + 'px'
       }">
    <ba-node-dropoff-path :nodeData="nodeData"
                          :layout="layout" />
  </svg>
</template>

<script>
import BaNodeDropoffPath from '@/components/trend/NodeDropoffPath'

export default {
  name: 'BaTargetingDropoffPath',
  components: {
    BaNodeDropoffPath
  },
  props: {
    nodeData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    layout () {
      return this.nodeData._layout
    },
    dropPathInfo () {
      return this.nodeData._dropPathInfo
    },
    top () {
      return this.dropPathInfo.y - this.layout.y
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.dropoff-path {
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
  z-index: -1;
}
</style>
